/**
 * Output utility spacing classes.
 *
 * @param {number | undefined} unit The unit spacing value.
 * @param {string} label The class name label.
 * @return {string} The utility class name.
 */

export default function outputSpacingClass(
  unit: number | undefined,
  label: string,
) {
  const isDecimalUnit = unit?.toString().includes('.');
  const formatDecimalUnit = unit?.toString().replace(/\./g, '_');

  if (unit === undefined) return;

  if (isDecimalUnit && unit > 0) {
    return `${label}-${formatDecimalUnit}`;
  }

  if (isDecimalUnit && unit < 0) {
    return `-${label}${formatDecimalUnit}`;
  }

  if (unit < 0) {
    return `-${label}${unit}`;
  }

  return `${label}-${unit}`;
}
